import CustomForm from "../CustomForm";
import {ValidationError} from "../ICustomForm";

export default abstract class CheckboxList extends CustomForm {

    protected errorMessage: string|null = null;

    public rewriteFormControls() {
        return true;
    }

    public onValidationErrors(errors: ValidationError[]): void {
        this.errorMessage = this.settings.app.messages.get('validateMessage');
    }
}